import { fabric } from 'fabric';

/***************** CANVAS GENERIC AREA *****************/
/**
 * Bloque les formes du canvas à ses dimensions.
 * @param event
 */
export function blockScalingBoundaries(event: fabric.IEvent<MouseEvent>) {
  const obj = event.target;
  if (obj.height > obj.canvas.height || obj.width > obj.canvas.width) {
    obj.set('scaleY', obj.scaleY);
    obj.set('scaleX', obj.scaleX);
  }
  obj.setCoords();
  if (obj.getBoundingRect().top - obj.cornerSize / 2 < 0 || obj.getBoundingRect().left - obj.cornerSize / 2 < 0) {
    obj.top = Math.max(obj.top, obj.top - obj.getBoundingRect().top + obj.cornerSize / 2);
    obj.left = Math.max(obj.left, obj.left - obj.getBoundingRect().left + obj.cornerSize / 2);
  }
  if (
    obj.getBoundingRect().top + obj.getBoundingRect().height + obj.cornerSize > obj.canvas.height ||
    obj.getBoundingRect().left + obj.getBoundingRect().width + obj.cornerSize > obj.canvas.width
  ) {
    obj.top = Math.min(
      obj.top,
      obj.canvas.height - obj.getBoundingRect().height + obj.top - obj.getBoundingRect().top - obj.cornerSize / 2
    );
    obj.left = Math.min(
      obj.left,
      obj.canvas.width - obj.getBoundingRect().width + obj.left - obj.getBoundingRect().left - obj.cornerSize / 2
    );
  }
}

/**
 * Fonction de blocage des bordures du canvas et du chevauchement
 * @param options L'évènement
 * @param canvas Le canvas
 */
export function lockCanvasBoundaries(options: fabric.IEvent<MouseEvent>, canvas: fabric.Canvas) {
  // Objet en cours
  const obj = options.target;
  // CANVAS BOUNDARIES
  // if object is too big ignore
  if (obj.height > obj.canvas.height || obj.width > obj.canvas.width) {
    return;
  }
  obj.setCoords();
  // top-left  corner
  if (obj.getBoundingRect().top < 0 || obj.getBoundingRect().left < 0) {
    obj.top = Math.max(obj.top, obj.top - obj.getBoundingRect().top);
    obj.left = Math.max(obj.left, obj.left - obj.getBoundingRect().left);
  }
  // bot-right corner
  if (
    obj.getBoundingRect().top + obj.getBoundingRect().height > obj.canvas.height ||
    obj.getBoundingRect().left + obj.getBoundingRect().width > obj.canvas.width
  ) {
    obj.top = Math.min(obj.top, obj.canvas.height - obj.getBoundingRect().height + obj.top - obj.getBoundingRect().top);
    obj.left = Math.min(
      obj.left,
      obj.canvas.width - obj.getBoundingRect().width + obj.left - obj.getBoundingRect().left
    );
  }
}

export async function generateHTMLImageElement(imgUrl: string): Promise<HTMLImageElement> {
  return new Promise(resolve => {
    fabric.util.loadImage(
      imgUrl,
      function (image: HTMLImageElement) {
        resolve(image);
      },
      null,
      'anonymous'
    );
  });
}
